import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import { getSchemaOrgForEndeavorVideo } from '../../../project/schema-org/js/schema-org-helpers';
import { EndeavorPlayer } from '../../endeavor-player';

const EndeavorCard = (props) => {
    const rootRef = useRef(null);
    const playerModel = {
        content: {
            videoId: props.video.id,
            autoplay: !!props.shouldPlayVideo
        }
    };

    return (
        <Fragment>
            <div
                className="stream-amg-card"
                tabIndex="0"
                role="button"
                aria-label="watch video"
                ref={rootRef}
            >
                <EndeavorPlayer {...playerModel} />
            </div>
            {getSchemaOrgForEndeavorVideo(props.video)}
        </Fragment>
    );
};

EndeavorCard.defaultProps = {
    video: {},
    autoplay: false,
};
EndeavorCard.propTypes = {
    video: PropTypes.object,
    autoplay: PropTypes.bool,
};

export default EndeavorCard;
